<template>
  <div id="modal_1"
    class="fixed top-0 z-50 flex items-start w-full h-screen overflow-scroll bg-gray-800 bg-opacity-50 font-open-sans">
    <div class="flex items-center justify-center w-full mx-auto max-w-8xl md:py-5 md:px-4 lg:px-16 xs-max:relative">
      <div class="relative flex flex-col items-center justify-center w-full max-w-5xl px-4 py-2 pt-5 mb-24 bg-white border-t-8 border-yellow-600 shadow-lg md:py-8 md:px-6 lg:px-14 xl:px-24">
        <div class="w-full modal-header">
          <div class="relative flex w-full px-2 mx-auto mb-3 gap-x-1 md:px-0">
            <div v-for="(item, index) in rewards" :key="index" class="relative w-1/3"
              :class="'text-' + item.position">
              <label class="relative w-20 text-base font-bold sm-max:inline-block sm:w-full md:text-xl -top-2 lg:-top-2">
                {{ item.option }}</label>
              <div class="relative grid items-center justify-start h-7 md:h-12" :class="[
                'bg-gray600',
                index == 0
                  ? 'rounded-l-full'
                  : index == rewards.length - 1
                    ? 'rounded-r-full'
                    : '',
              ]">
                <div class="absolute h-full duration-500 ease-in-out transition-width" :style="{
                  width: item.active ? '100%' : '0%',
                  backgroundColor: item.active ? '#7BBD41' : '#4B5563',
                }" :class="index == 0
                  ? 'rounded-l-full'
                  : index == rewards.length - 1
                    ? 'rounded-r-full'
                    : ''"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="relative w-full mt-4 md:mt-8 modal-body md:px-0">
          <div>
            <div class="py-2 text-center text-26 md:text-4xl bg-gray600">
              One-time Special Offer  
            </div>
            <div class="px-4 py-2 font-medium text-center bg-gray-100 text-22 md:py-6 md:text-25">
              Upgrade Your Order to Get FREE Gifts and <span class="font-bold">Big Savings</span>
            </div>
          </div>
          <div class="mt-8 text-2xl font-medium text-center md:mt-4 md:text-2xl">
            Click to select your upgrades
          </div>
          <div class="grid max-w-md grid-cols-12 m-auto mt-8 select-none gap-x-4 lg:gap-x-14 md:gap-y-8 gap-y-12 md:max-w-full">
            <div v-for="item in upgrades" :key="item.id"
              class="relative col-span-12 cursor-pointer md:col-span-6 select-item" @click="setActive(item)">
              <div class="absolute m-auto pointer-events-none -top-2 -left-2"></div>
              <div :class="[
                item.active
                  ? 'bg-[#E0EFD3] border-greenActive2'
                  : 'bg-white border-gray600',
                'md:pt-1 pt-1 border-4',
              ]">
                <div class="flex items-center px-4 lg:px-4 md:px-2 gap-x-4 md:gap-x-1 lg:gap-x-3 xl:gap-x-4">
                  <div class="w-7/12 sm:w-8/12 md:w-full">
                    <div class="relative grid py-2 sm-max:text-left mx-auto text-19 font-bold leading-6 text-center capitalize top-2.5 sm:text-xl md:text-lg lg:text-22" :class="item.active ? 'md:text-[#2C401A]' : ''">
                      {{ item.title }}
                    </div>
                    <div class="flex justify-center mt-2 aspect-auto">
                      <nuxt-img class="object-contain h-40 my-0 pointer-events-none xs-max:max-w-48 max-w-52 md:max-w-48 lg:max-w-52" loading="lazy" format="webp"
                        :alt="item.alt" :src="item.productImage"></nuxt-img>
                    </div>
                  </div>
                  <div class="pt-10 text-4xl font-bold md:text-5xl" :class="item.active ? 'md:text-[#2C401A]' : ''">
                    +
                  </div>
                  <div class="w-32 sm:w-4/12">
                    <div class="text-17 !leading-none text-center line-through md:text-19">
                      ${{ item.reward.discountedPrice.toFixed(2) }}
                    </div>
                    <div class="mb-2 font-bold text-center text-23 sm:text-2xl" :class="item.active ? 'md:text-[#2C401A]' : ''">
                      FREE
                    </div>
                    <nuxt-img class="object-cover w-auto m-auto lg:min-h-32 max-w-20 xl:max-w-24 lg:max-w-20 md:max-w-24 max-h-32" loading="lazy" format="webp" :alt="item.alt"
                      :src="item.reward.productImage"></nuxt-img>
                  </div>
                </div>
                <div class="text-white py-1.5 flex justify-center items-center gap-x-8 sm-max:px-2" :class="item.active
                  ? 'bg-[#33591F]'
                  : 'bg-gray900'">
                  <span class="line-through mt-0.5 font-light md:text-base sm:text-lg text-base">+${{ item.originalPrice }}</span>
                  <span class="font-bold text-28 sm:text-3xl md:text-28">+${{ item.discountedPrice }}</span>
                  <span class="text-base font-semibold sm:text-lg md:text-lg">{{ item.discount }}</span>
                </div>
                <div class="!leading-none tracking-[7px] text-center text-white font-ww-medium py-2 md:text-25 text-2xl" :class="item.active
                  ? 'bg-greenActive2'
                  : 'bg-[#D9D9D9]'">
                  <span style="filter: drop-shadow(0px 1px 1px rgba(0, 0, 0, 0.25));">
                    <span v-if="item.active">
                      SELECTED
                    </span>
                    <span v-else>
                      SELECT
                    </span>
                    
                  </span>
                </div>
              </div>
              <div class="px-6 mt-2 text-xl font-medium leading-7 text-center md:mt-3 md:text-21">
                {{ item.description }}
              </div>
            </div>
          </div>
        </div>
        <div class="w-full mt-8 sm-max:pb-6 md:mt-4">
          <div class="flex flex-col items-center justify-center gap-x-6 md:flex-col">
            <button v-if="getActiveLevel()" type="button" @click="submitRewards"
              class="!text-xl md:ml-0 btn--special lg:!text-3xl md-max:mt-0 !my-6 md:tracking-[7px]">
              YES! UPGRADE MY SAVINGS! <svg class="absolute hidden right-3 sm:block" width="22" height="46" viewBox="0 0 22 46" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M21.3642 24.5843C21.9205 23.9705 21.9205 22.9751 21.3642 22.3612C20.808 21.7473 19.9061 21.7473 19.3498 22.3612L21.3642 24.5843ZM2.48522 45.4196L21.3642 24.5843L19.3498 22.3612L0.470835 43.1965L2.48522 45.4196Z"
                    fill="white" />
                  <path
                    d="M19.4153 23.9954C19.9715 24.6093 20.8734 24.6093 21.4296 23.9954C21.9859 23.3815 21.9859 22.3862 21.4296 21.7723L19.4153 23.9954ZM0.536264 3.16014L19.4153 23.9954L21.4296 21.7723L2.55065 0.937025L0.536264 3.16014Z"
                    fill="white" />
                </svg>
            </button>
            <button v-else class="!text-lg md:ml-4 btn--special md:!text-2xl md-max:mt-0 xs-max:!text-base w-full !mx-0 !my-6" @click="cancelRewards">
              No thanks, I’ll pass on this one-time offer
            </button>
            <a v-if="getActiveLevel()" href="javascript:void(0)" @click="cancelRewards"
              class="block text-lg leading-none text-center underline border-b border-transparent md:text-lg focus:outline-none"
              data-v-82a0df31="">No thanks, I’ll pass on this one-time offer</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const runEngine = new Engine();

const props = defineProps({
  state: {
    type: Object,
    required: true,
  },
  upgradePackMap: {
    type: Object,
    default: null,
  },
});
const { state, upgradePackMap } = toRefs(props);
const trackEvent = inject("trackEvent");

const getPackQuantity = (pack) =>
  Number.parseInt(pack?.PackSize?.replace("x", ""), 10);

const parsePackPrice = (price) => {
  const normalizedPrice = Number.parseFloat(
    String(price ?? "").replace(/[^0-9.]/g, "")
  );

  return Number.isFinite(normalizedPrice) ? normalizedPrice : 0;
};

const getCurrentSelection = () => {
  const item = state.value.items[state.value.active.items];
  const variant = item?.Variants[state.value.active.variants];
  const pack = variant?.Pack[state.value.active.packs];

  return {
    item,
    variant,
    pack,
    variantID: variant?.variant?.VariantID,
  };
};

const getUpgradePack = (variant, pack) => {
  const targetPackSize = upgradePackMap.value
    ? upgradePackMap.value[pack?.PackSize]
    : `x${getPackQuantity(pack) * 2}`;

  if (!targetPackSize || targetPackSize === "xNaN") {
    return null;
  }

  return variant?.Pack?.find((candidate) => candidate.PackSize === targetPackSize) ?? null;
};

const getRegularPackPrice = (variant, pack) => {
  const quantity = getPackQuantity(pack);
  const unitPrice = Number.parseFloat(variant?.variant?.VariantPrice);

  if (!Number.isFinite(quantity) || !Number.isFinite(unitPrice)) {
    return 0;
  }

  return Number((quantity * unitPrice).toFixed(2));
};

const getDiscountedPackPrice = (pack) =>
  Number(parsePackPrice(pack?.Price).toFixed(2));

const getSavingsLabel = (regularPrice, discountedPrice) => {
  if (!regularPrice || !discountedPrice || discountedPrice >= regularPrice) {
    return "Upgrade Offer";
  }

  return `Save ${Math.round((1 - discountedPrice / regularPrice) * 100)}%`;
};

const formatBagLabel = (quantity) =>
  `${quantity} ${quantity === 1 ? "bag" : "bags"}`;

const upgrades = ref([
  {
    alt: "check level",
    discount: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      if (!variant || !upgradedPack) {
        return "Upgrade Offer";
      }

      return getSavingsLabel(
        getRegularPackPrice(variant, upgradedPack),
        getDiscountedPackPrice(upgradedPack)
      );
    }),
    active: true,
    title: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      if (!upgradedPack) {
        return "Upgrade your Order";
      }

      return `Upgrade to ${formatBagLabel(getPackQuantity(upgradedPack))}`;
    }),
    productImage: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      return upgradedPack?.Image?.url || pack?.Image?.url;
    }),
    originalPrice: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      if (!variant || !upgradedPack) {
        return 0;
      }

      return getRegularPackPrice(variant, upgradedPack);
    }),
    discountedPrice: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      if (!upgradedPack) {
        return 0;
      }

      return getDiscountedPackPrice(upgradedPack);
    }),
    id: 123456789,
    description: computed(() => {
      const { variant, pack } = getCurrentSelection();
      const upgradedPack = getUpgradePack(variant, pack);

      if (!upgradedPack) {
        return "Upgrade your order, plus a free stainless steel coffee scoop";
      }

      return `Upgrade to ${formatBagLabel(getPackQuantity(upgradedPack))}, plus a free stainless steel coffee scoop`;
    }),
    reward: {
      alt: "check level",
      active: true,
      title: "Coffee Scoop",
      quantity: 1,
      productImage: "assets/images/Layer22.png",
      id: 39492736647228,
      coupon: "Y1WWJRZHJYK5",
      discountedPrice: 8.00,
      position: 'center',
      option: "Upgrade Options",
    },
  },
  {
    alt: "check level",
    discount: "Save $30",
    active: false,
    title: "Signature Bundle",
    productImage: "assets/images/Layer1.png",
    originalPrice: 104.85,
    discountedPrice: 74.85,
    id: 32453656117308,
    quantity: 1,
    description: "One bag each of Espresso, Medium, & Dark Roast, plus a free cold brew glass",
    reward: {
      alt: "check level",
      active: false,
      title: "Cold brew Glass",
      productImage: "assets/images/CanGlass_2.png",
      id: 40354395586620,
      coupon: "Y1WWJRZHJYK5",
      quantity: 1,
      discountedPrice: 15.0,
      position: 'right',
         option: "Secure Checkout",
    },
  }
]);

const rewards = ref([
  {
    option: "Add to Cart",
    alt: "check level",
    position: 'left',
    active: true,
  },
  {
    option: "Upgrade Options",
    alt: "check level",
    position: 'center',
    active: true,
  },
  {
    option: "Secure Checkout",
    alt: "check level",
    position: 'right',
    active: false,
  },
]);

function setActive(selectedItem) {
  selectedItem.active = !selectedItem.active;
}

function getActiveLevel() {
  return upgrades.value.filter(item => item.active).length;
}

function getSelectedItems() {
  const selectedUpgrades = upgrades.value.filter(item => item.active);
  return [...selectedUpgrades];
}

const prepCheckout = items => {
  const { variant, pack, variantID } = getCurrentSelection();

  if (!variant || !pack || !variantID) {
    return;
  }

  const upgradedPack = getUpgradePack(variant, pack);

  // Build cart transform data
  const cartTransformData = {};
  
  // Add main variant cart transform data
  const activePack =
    items && items.find(i => i.id === 123456789) && upgradedPack ? upgradedPack : pack;
  cartTransformData[variantID] = {
    price: activePack.UnitPrice,
    storefrontTitle: activePack.StorefrontTitle || ''
  };

  let checkoutItems = [
    {
      id: variantID,
      quantity: pack.PackSize.replace("x", ""),
      packName: pack.PackName || pack.Name,
      coupon: pack.Coupon,
    },
  ];
  if (items) {
    const doubleOrder = items.find(item => item.id === 123456789);
    if (doubleOrder && upgradedPack) {
      checkoutItems[0] = {
        id: variantID,
        quantity: upgradedPack.PackSize.replace("x", ""),
        packName: upgradedPack.PackName || upgradedPack.Name,
        coupon: upgradedPack.Coupon,
      };
    }


    checkoutItems = [
      ...checkoutItems,
      ...items.filter((item) => item.id !== 123456789).map((item) => {
        return {
          id: item.id,
          quantity: item.quantity,
          coupon: item.coupon,
        };
      }),
      ...items.map((item) => {
        return {
          id: item.reward.id,
          quantity: item.reward.quantity,
          coupon: item.reward.coupon,
        };
      }),
      
    ];
  }

  runEngine.checkoutWithItems(checkoutItems, trackEvent, cartTransformData);
};

function submitRewards() {
  rewards.value[rewards.value.length - 1].active = true;
  const activeLevel = getActiveLevel();
  trackEvent({
    event: "experiment_event",
    label: "Upgrade Modal",
    action: "Upgrade My Order: Level " + activeLevel,
    value: activeLevel
  });
  const selectedItems = getSelectedItems();

  prepCheckout(selectedItems);
  // Checkout logic here with selectedItems
}

function cancelRewards() {
  rewards.value[rewards.value.length - 1].active = true;
  trackEvent({
    event: "experiment_event",
    label: "Upgrade Modal",
    action: "Deny Upgrade",
  });
  prepCheckout();
  // Checkout logic here without selected items
}
</script>

<style>
.swiper-wrapper {
  width: 100%;
  height: 100%;
}

.transition-width {
  transition: width 0.5s ease-in-out;
}
</style>
